var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "white-balance-sunny") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconen-drukke-dagen",
    transform: "translate(-57.000000, -16.000000)",
    fill: "#FF8100",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "white-balance-sunny",
    transform: "translate(57.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55,18.54 L3.96,19.95 L5.76,18.16 L4.34,16.74 M10,22.45 C10.32,22.45 12,22.45 12,22.45 L12,19.5 L10,19.5 M11,5.5 C7.6862915,5.5 5,8.1862915 5,11.5 C5,14.8137085 7.6862915,17.5 11,17.5 C12.5912989,17.5 14.1174224,16.867859 15.2426407,15.7426407 C16.367859,14.6174224 17,13.0912989 17,11.5 C17,8.18 14.31,5.5 11,5.5 M19,12.5 L22,12.5 L22,10.5 L19,10.5 M16.24,18.16 L18.04,19.95 L19.45,18.54 L17.66,16.74 M19.45,4.46 L18.04,3.05 L16.24,4.84 L17.66,6.26 M12,0.55 L10,0.55 L10,3.5 L12,3.5 M3,10.5 L0,10.5 L0,12.5 L3,12.5 M5.76,4.84 L3.96,3.05 L2.55,4.46 L4.34,6.26 L5.76,4.84 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.6799c67174c36c0008cc4824163c73ad.svg";
export { ForwardRef as ReactComponent };